export interface DynamicFormAttachmentSlot {
    fileKey: string;
    nameKey: string;
}

export interface DynamicFormAttachmentPayload {
    fileName: string;
    dataUrl: string;
}

/**
 * Builds the Salesforce submit body: Lead fields plus file attachments.
 * Upload file/name keys are omitted from `fields` and sent in `attachments`.
 */
export function buildDynamicFormSubmitPayload(
    fieldValues: Record<string, string | undefined>,
    attachmentSlotsByWidget: Record<string, DynamicFormAttachmentSlot[]>,
): {
    fields: Record<string, string | boolean>;
    attachments: DynamicFormAttachmentPayload[];
} {
    const attachmentFileKeys = new Set<string>();
    const attachmentNameKeys = new Set<string>();
    const attachments: DynamicFormAttachmentPayload[] = [];

    Object.values(attachmentSlotsByWidget).forEach(slots => {
        slots.forEach(({ fileKey, nameKey }) => {
            attachmentFileKeys.add(fileKey);
            attachmentNameKeys.add(nameKey);

            const dataUrl = fieldValues[fileKey];
            if (typeof dataUrl === "string" && dataUrl.startsWith("data:") && dataUrl.includes("base64,")) {
                const fileName = (fieldValues[nameKey] || "").trim() || "attachment.pdf";
                attachments.push({ fileName, dataUrl });
            }
        });
    });

    const fields: Record<string, string | boolean> = {};
    Object.keys(fieldValues).forEach(key => {
        if (attachmentFileKeys.has(key) || attachmentNameKeys.has(key)) {
            return;
        }

        const value = fieldValues[key];
        if (typeof value === "undefined") {
            return;
        }

        if (value === "true" || value === "false") {
            fields[key] = value === "true";
        } else {
            fields[key] = value;
        }
    });

    return { fields, attachments };
}
